import { useCallback } from 'react';
import { useKeyPressEvent as useBaseKeyPressEvent } from 'react-use';

export const useKeyPressEvent = (key: string, callback: (event: KeyboardEvent) => void) => {
  const callbackWithTargetCheck = useCallback(
    (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      if (target?.tagName === 'INPUT' || target?.tagName === 'TEXTAREA') {
        return;
      }
      callback(event);
    },
    [callback],
  );
  return useBaseKeyPressEvent(key, callbackWithTargetCheck);
};
